import React, { Component } from 'react'
import { Button, Checkbox, Collapse, DatePicker, Input, Modal, Pagination, Select, Spin, Table, Tooltip } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import CreateNewCommission from '../CreateNewCommission'
import { dateFormat, toLiteralMonth } from '../utils'
import commissions from '@services/commissions'
import * as styleClass from './style.scss'
import MentorCommissionList from '../MentorCommissionList'
import MathExpr, { op } from '../CreateNewCommission/MathExpr'
import { hRef, none } from '@pages/AgentCommissions/Reports/style.scss'

@inject((store: any) => {
    const { popupStore, authStore } = store

    return {
        popupStore,
        authStore
    }
})
@observer
export default class CommissionList extends Component<any> {
    constructor(props) {
        super(props)
        this.state = {
            edit: null,
            selectedNumerator: null,
            amount: null,
            showDelete: null,
            searchClientInput: '',
            selectedStatus: '',
            monthsToCharge: '',
            selectedReason: '',
            monthlySince: '',
            advancedPaymentAt: '',
            oldMethod: '',
            comment: '',
            percent: null,
            parentPercent: null,
            currentPage: 1,
            mentorCommissions: false,
            loader: false
        }
    }

    searchClient = e => {
        e.preventDefault()
        // const { getAgentCommissions } = this.props
        const { searchClientInput } = this.state
        // getAgentCommissions({ client_id: searchClientInput })
        this.paginate({ page: 1, client_id: searchClientInput })
    }

    resetSearch = e => {
        e.preventDefault()
        // const { getAgentCommissions } = this.props
        this.setState({ searchClientInput: '' })
        // getAgentCommissions()
        this.paginate()
    }

    openEdit = record => {
        this.setState({
            edit: record.id,
            showDelete: null,
            amount: record.amount,
            selectedStatus: record.status,
            selectedNumerator: record.numerator,
            monthsToCharge: record.months_to_charge,
            reason: record.reason,
            comment: record.comment,
            advancedPaymentAt: record.advanced_payment_at ? moment(record.advanced_payment_at) : undefined,
            monthlySince: record.monthly_since ? moment(record.monthly_since) : undefined,
            percent: record.current_percent,
            parentPercent: record.current_parent_percent,
            oldMethod: record.old_method
        })
    }

    closeEdit = () => {
        this.setState({
            amount: null,
            selectedNumerator: null,
            edit: null
        })
    }

    setSelectedNumerator = ({ commission, numerator }) => {
        this.setState({
            selectedNumerator: numerator,
            // monthlySince: numerator == 0 ? moment() : moment(), // moment(commission.monthly_since || '')
            monthlySince: numerator == 0 || !commission.monthly_since ? moment() : moment(commission.monthly_since)
        })
    }

    sendUpdate = commission => {
        const { getAgentCommissions, getAgentCommissionTotals } = this.props

        const {
            selectedNumerator,
            amount,
            selectedStatus,
            monthsToCharge,
            selectedReason,
            comment,
            advancedPaymentAt,
            monthlySince,
            oldMethod,
            percent,
            parentPercent
        } = this.state

        const payload = {
            commission_id: commission.id,
            numerator: selectedNumerator !== null ? selectedNumerator : commission.numerator,
            // Treat '' / undefined as "unchanged", but keep a deliberately-entered 0.
            amount: amount !== undefined && amount !== '' ? Number(amount) : commission.amount,
            current_parent_percent:
                parentPercent !== undefined && parentPercent !== ''
                    ? Number(parentPercent)
                    : commission.current_parent_percent,
            current_percent: percent !== undefined && percent !== '' ? Number(percent) : commission.current_percent,
            status: selectedStatus || commission.status,
            months_to_charge: monthsToCharge || commission.months_to_charge,
            cancellation_reason: selectedReason || commission.reason,
            comment: selectedReason === 'OTHER' ? comment || commission.comment : '',
            advanced_payment_at: advancedPaymentAt
                ? advancedPaymentAt.format('YYYY-MM-DD hh:mm:ss')
                : commission.advanced_payment_at,
            monthly_since: monthlySince ? monthlySince.format('YYYY-MM-DD hh:mm:ss') : commission.monthly_since,
            old_method: oldMethod,
            payment_type:
                selectedNumerator !== null ? (selectedNumerator == 0 ? 'MONTHLY' : 'YEARLY') : commission.payment_type
        }

        this.closeEdit()

        commissions
            .updateCommission(payload)
            .then(() => {
                // getAgentCommissions()
                this.paginate({ maintainPage: true })
                getAgentCommissionTotals()
                this.resetEditValues()
            })
            .catch(() => {
                this.resetEditValues()
            })
    }

    resetEditValues = () => {
        this.setState({
            selectedNumerator: undefined,
            amount: undefined,
            selectedStatus: undefined,
            monthsToCharge: undefined,
            selectedReason: undefined,
            parentPercent: undefined,
            percent: undefined,
            comment: undefined
        })
    }

    deleteCommission = commissionId => {
        const { getAgentCommissions } = this.props
        this.setState({ showDelete: null })

        commissions.deleteCommission({ id: commissionId }).then(() => {
            // getAgentCommissions()
            this.paginate({ maintainPage: true })
            alert('עמלה נמחקה בהצלחה')
        })
    }

    setPage = page => {
        this.setState({ currentPage: page })
    }

    paginate = (params = {}) => {
        // const { getAgentCommissions } = this.props
        // this.setState({ page, perPage }, () => getAgentCommissions({ page, perPage }))

        let { page, perPage, client_id, maintainPage } = params
        if (maintainPage) {
            const { commissionPagination } = this.props
            page = commissionPagination.page
            perPage = commissionPagination.perPage
        }
        this.props.paginateCommissions({ page: page || 1, perPage: perPage || 10, client_id, this_: this })

        // this.setState({ loader: false })
    }

    highlightRow = record => {
        return record.old_method ? styleClass.highLightRow : styleClass.commissionRow
    }

    onNumberInput = (event, key) => {
        event.value = event.value.replace(/[^0-9\.]/g, '')
        this.setState({ [key]: event.value })
    }

    columns = [
        {
            title: 'נוצר בתאריך',
            key: 'created_at',
            width: 100,
            align: 'right',
            render: (_, record) => {
                let [date, time] = moment(record.created_at)
                    .format('DD/MM/YYYY - HH:mm')
                    .split(' - ')
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span>{date}</span>
                        <span>{time}</span>
                    </div>
                )
            }
        },
        {
            title: 'עודכן בתאריך',
            key: 'updated_at',
            align: 'right',
            width: 100,
            render: (_, record) => {
                let [date, time] = moment(record.updated_at)
                    .format('DD/MM/YYYY - HH:mm')
                    .split(' - ')
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span>{date}</span>
                        <span>{time}</span>
                    </div>
                )
            }
        },
        {
            title: 'שם המינוי',
            key: 'sub_name',
            align: 'right',
            width: 250,
            render: (_, record) => {
                if (record.one_time) return <strong>{'עמלה חד פעמית'}</strong>
                return record.balance === 'CREDIT' && record.paid_at ? (
                    <Tooltip title={`פעיל מ: ${moment(record.paid_at).format('DD/MM/YYYY')}`}>
                        <div>{record.subscription_name}</div>
                    </Tooltip>
                ) : (
                    <div>{record.subscription_name}</div>
                )
            }
        },
        {
            title: 'מחיר',
            key: 'amount',
            align: 'center',
            width: 50,
            render: (_, record) => {
                const { edit } = this.state
                return edit == record.id && record.status === 'ACTIVE' ? (
                    <Input
                        style={{ minWidth: '40px', width: '60px', paddingLeft: '1px' }}
                        defaultValue={record.amount}
                        onInput={({ target }) => this.onNumberInput(target, 'amount')}
                    />
                ) : (
                    <div>{record.amount}</div>
                )
            }
        },
        {
            title: 'אחוז',
            key: 'percent',
            align: 'center',
            width: 80,
            render: (_, { id, status, current_percent }) => {
                const { edit } = this.state
                return edit == id && status === 'ACTIVE' ? (
                    <Input
                        style={{ minWidth: '40px', width: '60px', paddingLeft: '1px' }}
                        defaultValue={current_percent}
                        onInput={({ target }) => this.onNumberInput(target, 'percent')}
                    />
                ) : (
                    <div>{current_percent}</div>
                )
            }
        },
        {
            title: 'אחוז אב',
            key: 'parentPercent',
            align: 'center',
            width: 80,
            render: (_, { id, status, current_parent_percent, parent_agency_id }) => {
                const { edit } = this.state
                return edit == id && status === 'ACTIVE' && parent_agency_id ? (
                    <Input
                        style={{ minWidth: '40px', width: '60px', paddingLeft: '1px' }}
                        defaultValue={current_parent_percent}
                        onInput={({ target }) => this.onNumberInput(target, 'parentPercent')}
                    />
                ) : (
                    <div>{current_parent_percent}</div>
                )
            }
        },
        {
            title: 'זכות/חיוב',
            key: 'credit',
            align: 'center',
            width: 80,
            render: (_, record) => (
                <div style={{ color: `${record.balance === 'CREDIT' ? 'green' : 'red'}` }}>
                    {this.balance[record.balance]}
                </div>
            )
        },
        {
            title: 'סטטוס',
            key: 'status',
            align: 'center',
            width: 80,
            render: (_, record) => {
                return this.state.edit == record.id ? (
                    <Select
                        onChange={value => this.setState({ selectedStatus: value })}
                        defaultValue={record.status}
                        style={{
                            width: 100,
                            paddingRight: '0px'
                        }}
                    >
                        <Select.Option value="ACTIVE">פעיל</Select.Option>
                        <Select.Option value="CANCELED">בוטל</Select.Option>
                        {record.balance === 'CREDIT' && <Select.Option value="ON_HOLD">מושהה</Select.Option>}
                        {record.balance === 'DEBT' && <Select.Option value="CHARGED">שולם</Select.Option>}
                    </Select>
                ) : (
                    <div style={{ color: `${record.status === 'CANCELED' ? 'red' : 'green'}` }}>
                        {this.status[record.status]}
                    </div>
                )
            }
        },
        {
            title: 'נומרטור / חודשים לחיוב',
            key: 'numerator',
            align: 'center',
            width: 150,
            render: (_, record) => {
                const {
                    authStore: { roles }
                } = this.props

                if (record.one_time) {
                    return this.state.edit == record.id && (roles.includes('admin') || record.status === 'ACTIVE') ? (
                        <Select
                            defaultValue={record.numerator}
                            onChange={numerator => this.setSelectedNumerator({ commission: record, numerator })}
                            style={{
                                width: '85px',
                                paddingRight: '0px'
                            }}
                        >
                            {new Array(12).fill(null).map((_, index) => {
                                return (
                                    <Select.Option
                                        key={index.toString()}
                                        style={{ paddingRight: '0' }}
                                        value={index + 1}
                                    >
                                        {index + 1}
                                    </Select.Option>
                                )
                            })}
                        </Select>
                    ) : (
                        <span>{record.numerator}</span>
                    )
                }

                if (record.balance === 'DEBT') {
                    return this.state.edit == record.id && (roles.includes('admin') || record.status === 'ACTIVE') ? ( // admin can
                        <Select
                            defaultValue={record.months_to_charge}
                            onChange={monthsToCharge => this.setState({ monthsToCharge })}
                            style={{
                                width: '85px',
                                paddingRight: '0px'
                            }}
                        >
                            {new Array(12).fill(null).map((_, index) => {
                                return (
                                    <Select.Option
                                        key={index.toString()}
                                        style={{ paddingRight: '0' }}
                                        value={index + 1}
                                    >
                                        {index + 1}
                                    </Select.Option>
                                )
                            })}
                        </Select>
                    ) : (
                        <>{record.months_to_charge}</>
                    )
                } else if (record.balance === 'CREDIT') {
                    return this.state.edit == record.id && (roles.includes('admin') || record.status === 'ACTIVE') ? (
                        <Select
                            defaultValue={record.numerator}
                            onChange={numerator => this.setSelectedNumerator({ commission: record, numerator })}
                            style={{
                                width: '85px',
                                paddingRight: '0px'
                            }}
                        >
                            {new Array(13).fill(null).map((_, index) => {
                                return (
                                    <Select.Option key={index.toString()} style={{ paddingRight: '0' }} value={index}>
                                        {index}
                                    </Select.Option>
                                )
                            })}
                        </Select>
                    ) : (
                        <div style={{ height: '32px', lineHeight: '2.3' }}>{record.numerator}</div>
                    )
                }
            }
        },
        {
            title: 'סיבת ביטול',
            key: 'reason',
            align: 'right',
            width: 150,
            render: (_, record) => {
                if (!record.user_subscription_id && record.one_time) return null
                return record.balance === 'DEBT' ? (
                    this.state.edit !== record.id ? (
                        <div>{this.cancellationReasons[record.cancellation_reason]}</div>
                    ) : (
                        <Select
                            defaultValue={record.cancellation_reason}
                            onChange={reason => this.setState({ selectedReason: reason })}
                            style={{
                                width: '180px',
                                paddingRight: '0px'
                            }}
                        >
                            {Object.keys(this.cancellationReasons).map((reason, index) => {
                                return (
                                    <Select.Option key={index.toString()} value={reason}>
                                        {this.cancellationReasons[reason]}
                                    </Select.Option>
                                )
                            })}
                        </Select>
                    )
                ) : (
                    ''
                )
            }
        },
        {
            title: 'פירוט',
            maxWidth: '170px',
            key: 'comment',
            align: 'right',
            width: 80,
            render: (_, record) => {
                return this.state.edit !== record.id ? (
                    <a
                        href={'#'}
                        className={`${hRef} ${record.comment ? '' : none}`}
                        onClick={() => this.infoModal(record.comment)}
                    >
                        {'לפירוט'}
                    </a>
                ) : this.state.selectedReason === 'OTHER' ? (
                    <Input.TextArea
                        value={this.state.comment}
                        onChange={e => this.setState({ comment: e.target.value })}
                    />
                ) : (
                    ''
                )
            }
        },
        {
            title: 'נוצר ע״י',
            key: 'created_by',
            align: 'right',
            width: 100,
            render: (_, record) => {
                let createdBy = record.created_by === 'SYSTEM' ? 'מערכת' : record.created_by
                return <div>{createdBy}</div>
            }
        },
        {
            title: 'חיוב / זיכוי מחושב',
            key: 'calculated_yearly',
            align: 'right',
            width: 350,
            render: (_, record) => {
                if (this.state.edit == record.id && !record.one_time) {
                    const { advancedPaymentAt, monthlySince } = this.state
                    const handle = (field, date) => {
                        this.setState({ [field]: date })
                    }
                    return (
                        <div>
                            <div style={{ ...styles.column }}>
                                <span>{'עמלה חודשית ניתנה לראשונה:'}</span>
                                <DatePicker
                                    onChange={date => handle('monthlySince', date)}
                                    value={monthlySince}
                                    allowClear={true}
                                    style={{ width: '125px' }}
                                />
                            </div>

                            <div style={{ ...styles.column }}>
                                <span>{'עמלה ראשונית ניתנה ב:'}</span>
                                <DatePicker
                                    onChange={date => handle('advancedPaymentAt', date)}
                                    value={advancedPaymentAt}
                                    allowClear={true}
                                    style={{ width: '125px' }}
                                />
                            </div>
                        </div>
                    )
                } else if (record.one_time && (!record.user_subscription_id || !record.current_percent)) {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'start' }}>
                            <span>{record.amount}</span>
                        </div>
                    )
                } else if (record.one_time && record.user_subscription_id) {
                    const calculated = record.amount * record.current_percent
                    return (
                        <Tooltip
                            title={
                                <MathExpr
                                    tokens={[{ value: record.amount }, op('×'), { value: record.current_percent }]}
                                />
                            }
                        >
                            <span style={{ fontWeight: 'bold' }}>{`${calculated}`}</span>
                        </Tooltip>
                    )
                }

                const {
                    agentInfo: { percents, parent_agency_id, advanced_commission }
                } = this.props

                const parsedPrecents = JSON.parse(percents || '{}')
                const agentType = parent_agency_id ? 'sub' : 'general'
                const subscriptionName = record.subscription_name || ''
                const product = subscriptionName.includes('360')
                    ? 'MediWho360'
                    : subscriptionName.includes('Fly')
                    ? 'MediWhoFly'
                    : 'BestCare'

                const older_than = parsedPrecents[product].older_than
                    ? new Date(parsedPrecents[product].older_than)
                    : null
                const rateType =
                    !older_than || new Date(record.paid_at).getTime() > older_than.getTime()
                        ? record.payment_type == 'MONTHLY'
                            ? 'monthly'
                            : 'advanced'
                        : 'old'

                const defaultRate = parsedPrecents[product][agentType][rateType]
                let debtRate = ![null, undefined].includes(record.current_percent)
                    ? record.current_percent
                    : defaultRate
                debtRate = Number(debtRate)

                let monthlyRate = record.payment_type == 'MONTHLY' ? record.current_percent : null

                if (monthlyRate == null || monthlyRate == undefined) {
                    // rate might be == 0
                    monthlyRate = parsedPrecents[product][agentType][rateType == 'old' ? 'old' : 'monthly']
                }
                monthlyRate = Number(monthlyRate)
                let advancedRate =
                    record.advanced_percent ||
                    (record.payment_type == 'YEARLY' ? record.current_percent : null) ||
                    parsedPrecents[product][agentType][rateType == 'old' ? 'old' : 'advanced']
                advancedRate = Number(advancedRate)

                const firstPayment =
                    (record.advanced_months || (record.old_method ? 12 : advanced_commission)) *
                    advancedRate *
                    record.amount
                const duringFirstPayment = record.numerator > 0

                // debt rates ???

                let { monthly_since: monthlyAt, advanced_payment_at, old_method, advanced_months } = record

                if (monthlyAt) {
                    monthlyAt = dateFormat(monthlyAt)
                } else {
                    let date = new Date()
                    let fromYear = date.getFullYear()
                    let fromMonth = date.getMonth() + 1 + record.numerator
                    if (fromMonth > 12) {
                        fromMonth = fromMonth - 12
                        fromYear++
                    }
                    monthlyAt = `${toLiteralMonth(fromMonth)} ${fromYear}`
                }

                let advancedAt = advanced_payment_at
                if (advancedAt) {
                    advancedAt = dateFormat(advancedAt)
                } else {
                    let date = new Date()
                    let year = date.getFullYear()
                    let currentMonth = date.getMonth()
                    let dif = record.numerator - advanced_commission
                    let month = currentMonth + 1 + dif
                    if (month < 0) {
                        advancedAt = ''
                    } else {
                        if (month > 12) {
                            year++
                            month = month - 12
                        }
                        advancedAt = `${toLiteralMonth(month)} ${year}`
                    }
                }

                let advancedStr = old_method ? '' : `(${advanced_payment_at ? 'שולם ב' : 'לתשלום ב'}${advancedAt})`

                if (record.balance === 'CREDIT' && record.calculatedAmounts) {
                    let monthly = monthlyRate * record.amount

                    // let monthly = record.calculatedAmounts.monthlyAmount
                    // let yearly = record.calculatedAmounts.yearlyAmount

                    monthly = typeof monthly == 'number' ? monthly.toFixed(1).replace(/\.?0*$/, '') : ''
                    // yearly = typeof yearly == 'number' ? yearly.toFixed(1) : ''

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Tooltip
                                title={
                                    <MathExpr
                                        tokens={[
                                            { value: record.amount },
                                            op('×'),
                                            { value: monthlyRate.toFixed(9).replace(/\.?0*$/, '') }
                                        ]}
                                    />
                                }
                            >
                                <span style={{ fontWeight: `${duringFirstPayment ? 'normal' : 'bold'}` }}>
                                    {`חודשי (החל מ${monthlyAt}): ${monthly}`}
                                </span>
                            </Tooltip>

                            <Tooltip
                                title={
                                    <MathExpr
                                        tokens={[
                                            { value: record.amount },
                                            op('×'),
                                            { value: advancedRate.toFixed(9).replace(/\.?0*$/, '') },
                                            op('×'),
                                            { value: old_method ? 12 : advanced_months || advanced_commission }
                                        ]}
                                    />
                                }
                            >
                                <span style={{ fontWeight: `${duringFirstPayment ? 'bold' : 'normal'}` }}>
                                    {`עמלה ${old_method ? 'משונתת' : 'ראשונית'} ${advancedStr}: ${firstPayment
                                        .toFixed(1)
                                        .replace(/\.?0*$/, '')}`}
                                </span>
                            </Tooltip>
                        </div>
                    )
                } else if (record.balance === 'DEBT') {
                    // debt rates? reverse engineer by user_subscription(s) ?? is it possible?

                    return (
                        <Tooltip
                            title={
                                <MathExpr
                                    tokens={[
                                        { value: record.amount },
                                        op('×'),
                                        { value: debtRate.toFixed(9).replace(/\.?0*$/, '') },
                                        op('×'),
                                        { value: record.months_to_charge }
                                    ]}
                                />
                            }
                        >
                            {(record.amount * debtRate * record.months_to_charge).toFixed(1).replace(/\.?0*$/, '')}
                        </Tooltip>
                    )
                }
            }
        },
        {
            title: '',
            key: 'oldMethod',
            align: 'right',
            width: 150,
            render: (_, record) => {
                if (record.one_time || this.state.edit != record.id) return ''
                const { oldMethod } = this.state
                return (
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <span>{'שיטה ישנה:'}</span>
                        <Checkbox
                            value={oldMethod}
                            defaultChecked={record.old_method}
                            onChange={() => this.setState({ oldMethod: !oldMethod })}
                            disabled={record.numerator == 0}
                        />
                    </div>
                )
            }
        }
    ]

    moneyColumns = [
        {
            title: 'עריכה',
            key: 'edit',
            width: '120px',
            align: 'right',
            render: (_, record) => {
                return (
                    <div>
                        {this.state.edit == record.id ? (
                            <div style={{ display: 'flex' }}>
                                <Button style={{ cursor: 'pointer' }} onClick={this.closeEdit}>
                                    ביטול
                                </Button>
                                <Button
                                    style={{ cursor: 'pointer', marginRight: '15px' }}
                                    onClick={() => this.sendUpdate(record)}
                                >
                                    שמירה
                                </Button>
                            </div>
                        ) : (
                            <Button style={{ cursor: 'pointer' }} onClick={() => this.openEdit(record)}>
                                עריכה
                            </Button>
                        )}
                    </div>
                )
            }
        }
    ]

    adminColumns = [
        {
            title: '',
            key: 'delete',
            width: '100px',
            render: (_, record) => {
                return (
                    <div>
                        {this.state.showDelete == record.id ? (
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span>האם את/ה בטוח/ה שברצונך למחוק את הרשומה?</span>
                                <div style={{ display: 'flex' }}>
                                    <Button
                                        style={{ cursor: 'pointer', marginLeft: '10px' }}
                                        onClick={() => this.deleteCommission(record.id)}
                                    >
                                        כן
                                    </Button>
                                    <Button
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => this.setState({ showDelete: null })}
                                    >
                                        לא
                                    </Button>
                                </div>
                            </div>
                        ) : (
                            <Button
                                style={{ cursor: 'pointer', border: 'solid red 1px', color: 'red' }}
                                onClick={() => this.setState({ showDelete: record.id, edit: null })}
                            >
                                מחק
                            </Button>
                        )}
                    </div>
                )
            }
        }
    ]

    cancellationReasons = {
        NOT_INTERSTED: 'לקוח לא מעוניין',
        COMPETITORS: 'מתחרים',
        DOUBLE_SUBSCRIPTION: 'כפל מנויים',
        DENIAL_TRANSACTION: 'הכחשת עסקה',
        STO_CANCELLED: 'ביטול הוראת קבע',
        RETURNED_CHARGE: 'חיוב חוזר',
        BLOCKING_PAYMENT_METHOD: 'חסימת אמצעי תשלום',
        EXPENSIVE_PRICE: 'מחיר יקר',
        BAD_SERVICE: 'חווית שירות לא טובה',
        NOT_USED: 'לא השתמש בשירות',
        UPGRADE: 'שדרוג מינוי',
        CHANGE_SUBSCRIPTION: 'שינוי מינוי',
        OTHER: 'אחר'
    }

    status = {
        ACTIVE: 'פעיל',
        CANCELED: 'בוטל',
        ON_HOLD: 'מושהה',
        CHARGED: 'שולם'
    }

    balance = {
        CREDIT: 'זכות',
        DEBT: 'חוב'
    }

    infoModal = text => Modal.info({ title: text, okType: 'primary' })

    render() {
        let {
            commissions,
            agentInfo,
            // getAgentCommissions,
            getAgentCommissionTotals,
            authStore: { roles },
            commissionPagination: { total, perPage, page, count },
            popupStore: { popupType }
        } = this.props
        const { currentPage, searchClientInput, mentorCommissions } = this.state

        // let total, commissionsToDispaly

        // if (commissions && commissions !== 'loading') {
        //     total = commissions.length
        //     commissionsToDispaly = commissions.slice((currentPage * 10) - 10, (currentPage * 10))
        // } else {
        //     total = 1
        //     commissionsToDispaly = [{ client_id: '', commissions: [{}] }]
        // }

        let tableColumns = []

        if (roles.includes('admin')) {
            tableColumns = [...this.columns, ...this.moneyColumns, ...this.adminColumns]
        } else if (roles.includes('money')) {
            tableColumns = [...this.columns, ...this.moneyColumns]
        } else {
            tableColumns = [...this.columns]
        }

        const isNewComPopup = popupType === 'newCommission'

        return (
            <>
                {isNewComPopup ? (
                    <CreateNewCommission
                        getAgentCommissionTotals={getAgentCommissionTotals}
                        // getAgentCommissions={getAgentCommissions}
                        getAgentCommissions={this.paginate}
                        agentCommissions={commissions}
                        agentInfo={agentInfo}
                    />
                ) : null}

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <form onSubmit={this.searchClient} style={{ display: 'flex', alignItems: 'center', width: '40%' }}>
                        <span>חיפוש לפי מזהה לקוח</span>
                        <Input
                            style={{ maxWidth: '200px', marginInline: '20px' }}
                            value={searchClientInput}
                            onChange={e => this.setState({ searchClientInput: e.target.value })}
                        />
                        <Button htmlType="submit">חיפוש</Button>
                        <Button onClick={this.resetSearch}>איפוס</Button>
                    </form>

                    <Button
                        onClick={() => this.props.popupStore.togglePopup('newCommission')}
                        style={{ margin: '10px 20px' }}
                    >
                        יצירת חיוב / זיכוי
                    </Button>
                </div>
                {commissions !== 'loading' && !this.state.loader ? (
                    <Collapse
                        style={{ flexDirection: 'column' }}
                        accordion
                        onChange={() => this.setState({ mentorCommissions: '' })}
                    >
                        {(commissions || [{}]).map(client => {
                            return client.client_id ? (
                                <Collapse.Panel
                                    key={client.client_id.toString()}
                                    header={`${client.client_first_name} ${client.client_last_name} - ${client.client_id}`}
                                >
                                    <Button
                                        onClick={() =>
                                            this.props.popupStore.togglePopup('newCommission', {
                                                client_id: client.client_id
                                            })
                                        }
                                        style={{ float: 'left', margin: '0 0 10px 0', zIndex: '1' }}
                                    >
                                        יצירת חיוב / זיכוי
                                    </Button>

                                    <Button
                                        onClick={() => {
                                            if (mentorCommissions) {
                                                this.setState({ mentorCommissions: '' })
                                            } else {
                                                this.setState({ mentorCommissions: client.client_id })
                                            }
                                        }}
                                    >
                                        {mentorCommissions ? 'צפייה בעמלות סוכן' : 'צפייה בעמלות מנטור'}
                                    </Button>

                                    {mentorCommissions == client.client_id ? (
                                        <MentorCommissionList client_id={client.client_id} agentInfo={agentInfo} />
                                    ) : (
                                        <Table
                                            rowKey={'id'}
                                            scroll={{ x: 800 }}
                                            bordered={true}
                                            columns={tableColumns}
                                            dataSource={client.commissions}
                                            pagination={false}
                                            rowClassName={this.highlightRow}
                                        />
                                    )}
                                </Collapse.Panel>
                            ) : (
                                ''
                            )
                        })}
                    </Collapse>
                ) : (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '471px' }}>
                        <Spin tip="טוען"></Spin>
                    </div>
                )}

                {/* <Pagination style={{ marginTop: '20px' }} current={currentPage} onChange={this.setPage} total={total}/> */}
                <Pagination
                    style={{ marginTop: '20px' }}
                    size="small"
                    current={page}
                    // total={total * perPage}
                    total={total}
                    onChange={(page, perPage) => {
                        this.setState({ loader: true })
                        this.paginate({ page, perPage })
                    }}
                    onShowSizeChange={(page, perPage) => this.paginate({ page, perPage })}
                    showSizeChanger
                />
            </>
        )
    }
}

const styles = {
    column: {
        display: 'flex',
        flexDirection: 'column'
    }
}
